(() => {
 function prepare() {
  const template=document.querySelector('[data-mc-fit-template]');
  const target=document.querySelector('[data-mc-fit-reference]');
  if(template&&target&&!target.children.length)target.append(template.content.cloneNode(true));
  document.querySelectorAll('.variant-wrapper--mc-color input').forEach(input=>{
   if(input.dataset.mcV6Bound)return;
   input.dataset.mcV6Bound='true';
   input.addEventListener('change',()=>{
    const section=input.closest('.product-section');
    const label=section?.querySelector('[data-variant-color-label]');
    if(input.checked&&label)label.textContent=input.value;
   });
  });
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',prepare);else prepare();
 document.addEventListener('shopify:section:load',prepare);
})();
